/* src/app/shared/components/ag-label/ag-label.component.scss */
.label-box {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  font-family: "Poppins-Medium";
  font-style: normal;
  font-size: 12px;
  line-height: 140%;
  width: fit-content;
  gap: 8px;
  border-radius: 8px;
}
.small {
  height: 24px;
  padding: 8px;
}
.big {
  height: 32px;
  padding: 8px 12px;
}
.Default.Outlined {
  background-color: #e4d7f3;
  color: #4f356e;
  border: 1px solid #4f356e;
}
.Default.Outlined .img {
  filter: brightness(0) saturate(100%) invert(22%) sepia(10%) saturate(3245%) hue-rotate(225deg) brightness(100%) contrast(91%);
}
.Default.Standard {
  background-color: #e4d7f3;
  color: #4f356e;
}
.Default.Standard .img {
  filter: brightness(0) saturate(100%) invert(22%) sepia(10%) saturate(3245%) hue-rotate(225deg) brightness(100%) contrast(91%);
}
.Default.Dark {
  background-color: #cb9def;
  color: #ffffff;
}
.Default.Dark .img {
  filter: brightness(0) invert(1);
}
.Info.Outlined {
  background-color: #f7faff;
  border: 1px solid #385480;
  color: #385480;
}
.Info.Outlined .img {
  filter: brightness(0) saturate(100%) invert(31%) sepia(10%) saturate(2494%) hue-rotate(178deg) brightness(94%) contrast(91%);
}
.Info.Standard {
  background-color: #f7faff;
  color: #385480;
}
.Info.Standard .img {
  filter: brightness(0) saturate(100%) invert(31%) sepia(10%) saturate(2494%) hue-rotate(178deg) brightness(94%) contrast(91%);
}
.Info.Dark {
  background-color: #70a8ff;
  color: #ffffff;
}
.Info.Dark .img {
  filter: brightness(0) invert(1);
}
.Success.Outlined {
  background-color: #eafbee;
  border: 1px solid #4aba96;
  color: #2c6e58;
}
.Success.Outlined .img {
  filter: brightness(0) saturate(100%) invert(32%) sepia(74%) saturate(331%) hue-rotate(109deg) brightness(95%) contrast(87%);
}
.Success.Standard {
  background-color: #eafbee;
  color: #2c6e58;
}
.Success.Standard .img {
  filter: brightness(0) saturate(100%) invert(32%) sepia(74%) saturate(331%) hue-rotate(109deg) brightness(95%) contrast(87%);
}
.Success.Dark {
  background-color: #4aba96;
  color: #ffffff;
}
.Success.Dark .img {
  filter: brightness(0) invert(1);
}
.Warning.Outlined {
  background-color: #fff0ca;
  border: 1px solid #ffd67a;
  color: #806b3d;
}
.Warning.Outlined .img {
  filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(341%) hue-rotate(3deg) brightness(96%) contrast(92%);
}
.Warning.Standard {
  background-color: #fff0ca;
  color: #806b3d;
}
.Warning.Standard .img {
  filter: brightness(0) saturate(100%) invert(39%) sepia(56%) saturate(341%) hue-rotate(3deg) brightness(96%) contrast(92%);
}
.Warning.Dark {
  background-color: #ffd67a;
  color: #ffffff;
}
.Warning.Dark .img {
  filter: brightness(0) invert(1);
}
.Fail.Outlined {
  background-color: #fff2f0;
  border: 1px solid #e55e5e;
  color: #993f3f;
}
.Fail.Outlined .img {
  filter: brightness(0) saturate(100%) invert(30%) sepia(45%) saturate(955%) hue-rotate(314deg) brightness(89%) contrast(86%);
}
.Fail.Standard {
  background-color: #fff2f0;
  color: #993f3f;
}
.Fail.Standard .img {
  filter: brightness(0) saturate(100%) invert(30%) sepia(45%) saturate(955%) hue-rotate(314deg) brightness(89%) contrast(86%);
}
.Fail.Dark {
  background-color: #e55e5e;
  color: #ffffff;
}
.Fail.Dark .img {
  filter: brightness(0) invert(1);
}
.Neutral.Outlined {
  background-color: #f2f2f2;
  border: 1px solid #a6a6a6;
  color: #222222;
}
.Neutral.Standard {
  background-color: #f2f2f2;
  color: #222222;
}
.Neutral.Dark {
  background-color: #a6a6a6;
  color: #ffffff;
}
.Ordinary {
  background-color: #ffffff;
  border: 1px solid #222222;
  color: #222222;
}
.Sky.Outlined {
  background-color: #f7faff;
  border: 1px solid #6e89da;
  color: #385480;
}
.Sky.Outlined .img {
  filter: brightness(0) invert(1);
}
.Sky.Standard {
  background-color: #e0e9f9;
  color: #3753be;
}
.Sky.Standard .img {
  filter: brightness(0) saturate(100%) invert(31%) sepia(10%) saturate(2494%) hue-rotate(178deg) brightness(94%) contrast(91%);
}
.Sky.Dark {
  background-color: #6e89da;
  color: #ffffff;
}
.Sky.Dark .img {
  filter: brightness(0) invert(1);
}
.Purple.Outlined {
  background-color: #e4d7f3;
  border: 1px solid #4f356e;
  color: #4f356e;
}
.Purple.Outlined .img {
  filter: brightness(0) invert(1);
}
.Purple.Standard {
  background-color: #e4d7f3;
  color: #4f356e;
}
.Purple.Standard .img {
  filter: brightness(0) invert(1);
}
.Purple.Dark {
  background-color: #4f356e;
  color: #ffffff;
}
.Purple.Dark .img {
  filter: brightness(0) invert(1);
}
.img {
  max-height: 16px;
  max-width: 16px;
}
/*# sourceMappingURL=ag-label.component.css.map */
